import React from "react";
import PropTypes from "prop-types";
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  OutlinedInput,
  Checkbox,
  ListItemText,
} from "@mui/material";
import { monthOptions } from "./SepaUtils";

export default function SepaFilters({
  bookMonth,
  onChangeBookMonth,
  collectionDate,
  onChangeCollectionDate,
  sites,
  selectedSiteIds,
  onChangeSelectedSiteIds,
}) {
  return (
    <Grid container spacing={2} sx={{ mb: 2 }}>
      <Grid item xs={12} sm={6} md={4}>
        <FormControl fullWidth>
          <InputLabel id="bm-label">Abbuchen für</InputLabel>
          <Select
            labelId="bm-label"
            label="Abbuchen für"
            value={bookMonth}
            onChange={(e) => onChangeBookMonth(e.target.value)}
          >
            {monthOptions().map((m) => (
              <MenuItem key={m.id} value={m.value}>
                {m.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <TextField
          fullWidth
          label="Fälligkeitsdatum"
          type="date"
          value={collectionDate}
          onChange={(e) => onChangeCollectionDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <FormControl fullWidth>
          <InputLabel id="site-filter-label">Standorte</InputLabel>
          <Select
            multiple
            labelId="site-filter-label"
            label="Standorte"
            value={selectedSiteIds}
            onChange={(e) => onChangeSelectedSiteIds(e.target.value)}
            input={<OutlinedInput label="Standorte" />}
            renderValue={(selected) => {
              if (!selected?.length) return "Alle";
              const map = new Map(sites.map((s) => [String(s._id || s.id), s]));
              return selected
                .map((id) => map.get(String(id))?.siteName || "—")
                .join(", ");
            }}
          >
            {sites.map((s) => {
              const id = String(s._id || s.id);
              return (
                <MenuItem key={id} value={id}>
                  <Checkbox checked={selectedSiteIds.indexOf(id) > -1} />
                  <ListItemText primary={s.siteName} />
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
}

SepaFilters.propTypes = {
  bookMonth: PropTypes.string.isRequired,
  onChangeBookMonth: PropTypes.func.isRequired,
  collectionDate: PropTypes.string.isRequired,
  onChangeCollectionDate: PropTypes.func.isRequired,
  sites: PropTypes.array.isRequired,
  selectedSiteIds: PropTypes.array.isRequired,
  onChangeSelectedSiteIds: PropTypes.func.isRequired,
};
